import $ from 'jquery';
import Component from './index';
import SimpleBar from 'simplebar';

class Dropdown extends Component {
    mount() {
        // this.$el is the context
        this.$button = $('button', this.$el);
        this.$link = $('a', this.$el);
        this.$list = $('.js-dropdown-list', this.$el);
        this.$body = $('body');
        // if there's no link with a selected class then it's the "All" option
        this.$activeLink = this.$list.find('.selected').first() || this.$link.first();

        this.initCustomScrollbar();

        this.addEventHandlers();
    }

    initCustomScrollbar() {
        new SimpleBar(this.$list[0]);
    }

    addEventHandlers() {
        this.$button.on('click', e => {
            e.preventDefault();
            this.toggle();
        });

        this.$link.on('click', e => {
            e.preventDefault();
            this.$activeLink = $(e.currentTarget);
            this.updateLinks();
            this.close();
            this.trigger('select', e.currentTarget);
        });
    }

    updateLinks() {
        // set the dropdown button text to the selected text
        this.$button.find('span').text(this.$activeLink.text());
        // remove any selected classes in the dropdown list
        this.$list.find('a').removeClass('selected');
        // add selected class to selected link
        this.$activeLink.addClass('selected');
    }

    toggle() {
        const isActive = this.$list.hasClass('active');
        return isActive ? this.close() : this.open();
    }

    open() {
        this.$list.addClass('active');
        this.addDocumentListeners();
        this.trigger('open');
    }

    close() {
        this.$list.removeClass('active');
        this.removeDocumentListeners();
        this.trigger('close');
    }

    addDocumentListeners() {
        $(document).on(`click.${this.id} touchstart.${this.id}`, e => {
            if (!$(e.target).closest(this.$el).length) {
                this.close();
            }
        });

        this.$body.on(`keydown.${this.id}`, e => {
            this.handleKeydown(e);
        });
    }

    removeDocumentListeners() {
        this.$body.off(`keydown.${this.id}`);
        $(document).off(`click.${this.id} touchstart.${this.id}`);
    }

    handleKeydown(e) {
        // use escape key to close dropdown
        if (e.which === 27) {
            e.preventDefault();
            this.close();
        }
    }

    unmount() {
        this.removeEventHandlers();
    }

    removeEventHandlers() {
        this.$button.off('click');
        this.$link.off('click');
        this.removeDocumentListeners();
    }
}

export default Dropdown;
